/* eslint-disable */

import * as runtime from '../runtime';
import type {
  CancelCommerceIntentDto,
  CommerceIntentDto,
  CommerceProgramDiscoveryDto,
  CommerceQuoteDto,
  CommerceSurfaceCapabilitiesDto,
  ConfirmCommerceIntentDto,
  CreateCommerceIntentDto,
  CreateCommerceQuoteDto,
  CreatePublicCommerceTargetDraftDto,
  PublicCommerceTargetDraftDto,
} from '../models';

export interface DiscoverProgramsRequest {
  orgId: number;
}

export interface CreateTargetDraftRequest {
  orgId: number;
  createPublicCommerceTargetDraftDto: CreatePublicCommerceTargetDraftDto;
}

export interface QuoteRequest {
  orgId: number;
  createCommerceQuoteDto: CreateCommerceQuoteDto;
}

export interface CreateIntentRequest {
  orgId: number;
  createCommerceIntentDto: CreateCommerceIntentDto;
}

export interface ConfirmIntentRequest {
  orgId: number;
  confirmCommerceIntentDto: ConfirmCommerceIntentDto;
}

export interface GetIntentRequest {
  orgId: number;
  intentId: string;
}

export interface CancelIntentRequest {
  orgId: number;
  cancelCommerceIntentDto: CancelCommerceIntentDto;
}

export class PublicCommerceApi extends runtime.BaseAPI {

  async capabilities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceSurfaceCapabilitiesDto> {
    const response = await this.request({ path: '/commerce/public/capabilities', method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async discoverPrograms(requestParameters: DiscoverProgramsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommerceProgramDiscoveryDto>> {
    const response = await this.request({ path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/programs`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async createTargetDraft(requestParameters: CreateTargetDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicCommerceTargetDraftDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/targets/draft`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createPublicCommerceTargetDraftDto,
    }, initOverrides);
    return response.json();
  }

  async quote(requestParameters: QuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceQuoteDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/quotes`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createCommerceQuoteDto,
    }, initOverrides);
    return response.json();
  }

  async createIntent(requestParameters: CreateIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceIntentDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/intents`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createCommerceIntentDto,
    }, initOverrides);
    return response.json();
  }

  async confirmIntent(requestParameters: ConfirmIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceIntentDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/intents/confirm`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.confirmCommerceIntentDto,
    }, initOverrides);
    return response.json();
  }

  async getIntent(requestParameters: GetIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceIntentDto> {
    const response = await this.request({ path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/intents/${encodeURIComponent(String(requestParameters.intentId))}`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async cancelIntent(requestParameters: CancelIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommerceIntentDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/commerce/public/orgs/${encodeURIComponent(String(requestParameters.orgId))}/intents/cancel`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.cancelCommerceIntentDto,
    }, initOverrides);
    return response.json();
  }

}
